import React from 'react'
import './styles.scss'

interface Props {
  date: Date
}

export const Calendar = ({ date }: Props) => {
  return (
    <div className='calendar'>
      <div className='top'>
        {date.toLocaleString('fr-CH', { month: 'long' })}
      </div>
      <div className='bottom'>{date.getDate()}</div>
    </div>
  )
}
